module.exports = __webpack_public_path__ + "img/circle-add.2c985a62.svg";